import React from "react";

// styles
import styles from "./styles.module.css";

interface Props {
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const ImageUpload = ({ handleChange }: Props) => {
  return (
    <input
      className={styles["image_upload"]}
      type="file"
      name="picture"
      id="picture"
      accept="image/x-png,image/jpeg,image/jpg,image/webp,image/png"
      style={{
        background: `url('/assets/images/svg/uploadContractImage.svg')`,
      }}
      onChange={handleChange}
      multiple
    />
  );
};

export default ImageUpload;
